<template>
  <div>
    <header-bar>
      著作権申請完了
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">届出内容登録 - 届出内容登録完了</h3>
      </div>
      <div class="page-block__inner">
        <div class="form-complete-area">
          <div class="form-complete-area__title"> 著作権申請完了</div>
          <div class="form-complete-area__lead">「{{ title }}」の届出申請を受付けました。</div>
          <div class="form-complete-area__text">
            審査完了後にあらためてメールにてご連絡いたしますので、
            今しばらくお待ちください。<br><br>
            <template
              v-if="hasGuest">
              アカウント管理者さま本人以外の作詞 / 作曲 / 補作詞 / 補作曲として設定された<br>
              メールアドレスへ著作権スプリットへの招待メールが送信されました。<br>
              著作権スプリットの確定までしばらくお待ちください。
            </template>
          </div>
          <div class="c-btn-wrap">
            <router-link
              :to="{ name: 'index' }"
              class="c-btn c-btn--back">
              トップへ戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'CopyrightCompleted',
  components: { HeaderBar },
  data() {
    return {
      title: null,
      hasGuest: false,
    }
  },
  mounted() {
    this.title = window.sessionStorage.getItem('copyrightTitle')
    this.hasGuest = window.sessionStorage.getItem('hasGuest') === 'true'
    window.sessionStorage.removeItem('copyrightTitle')
    window.sessionStorage.removeItem('hasGuest')
  },
}
</script>
